import type { TextEntryFieldProps } from '~/interfaces/TextEntryFieldProps'
import { fieldPresentationDefaults } from './fieldPresentationDefaults'

/** Runtime defaults shared by single-line and multiline text entry. */
export const textEntryFieldDefaults = {
  ...fieldPresentationDefaults,
  maxlength: undefined,
  modelValue: '',
  placeholder: ''
} satisfies Required<TextEntryFieldProps>
